// SSO Configuration mode constants
export const SSO_CONFIG_MODES = {
  ADD_ADMIN: 'addAdmin',
  ADD_MEMBER_APP: 'addMemberApp',
  EDIT_ADMIN: 'editAdmin',
  EDIT_MEMBER_APP: 'editMemberApp'
} as const;

// SSO Configuration modes type
export type SSOConfigMode = typeof SSO_CONFIG_MODES[keyof typeof SSO_CONFIG_MODES];
